// Shared Service File
import { Injectable, Compiler } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from  '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { PopupLogoutComponent } from '../users/popup/popup-logout.component';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LocalStorage } from '../services/local-storage';
import {IndexedDBService} from '.././services/indexdb.service';
// import { LoaderService } from '../services/Spinner.service';

declare var $:any;
// import {HeaderMenuComponent} from '.././common/headermenu.component'
//import {} from '@types/googlemaps';
// declare var OneSignal: any;
@Injectable()
export class SharedService {
  currentLatLong=[]; 
  imageurl:string="";
  location= {};  
  lat1; 
  long1;
  currentLat1;
  currentlong1; 
  distcalc: number=0;
   shareUrl;
   apiUrl;
//Dev url


// private baseUrl: string = 'https://dev.zizazz.com/ziz/api/v1/';
// private baseUrlv2: string = 'https://dev.zizazz.com/ziz/api/v2/';
  
 //Qa url

//  private baseUrl: string = 'https://qa.zizazz.com/ziz/api/v1/';

// Staging URL

//private baseUrl: string = 'https://staging.zizazz.com/ziz/api/v1/';
//private baseUrlv2: string = 'https://staging.zizazz.com/ziz/api/v2/';
 //Prod URL

  private baseUrl: string = 'https://prod.zizazz.com/ziz/api/v1/';
  private baseUrlv2: string = 'https://prod.zizazz.com/ziz/api/v2/';





    rerenderLogoutpopup: boolean;
   constructor(private http: Http, 
    private dialogService:DialogService,
    public router: Router, 
    public Popuplogout: PopupLogoutComponent, 
    private localstorage : LocalStorage, 
    public indexedDB: IndexedDBService, 
    private _compiler: Compiler, 
    // private loaderService : LoaderService
    ) { 
       this.rerenderLogoutpopup = true;
 //Dev url
// this.shareUrl = 'https://dev.zizazz.com/ziz/api/v1/master/getCampaignBySharedId/';
  
 //Qa url
//  this.shareUrl = 'https://qa.zizazz.com/ziz/api/v1/master/getCampaignBySharedId/';

// Staging URL
// this.shareUrl = 'https://staging.zizazz.com/ziz/api/v1/master/getCampaignBySharedId/';

//prod url

  this.shareUrl = 'https://prod.zizazz.com/ziz/api/v1/master/getCampaignBySharedId/';


//Dev url
// this.apiUrl = 'https://dev.zizazz.com/ziz/api/v1/';
  
 //Qa url
//  this.apiUrl = 'https://qa.zizazz.com/ziz/api/v1/';

// Staging URL
// this.apiUrl = 'https://staging.zizazz.com/ziz/api/v1/';

//prod url

  this.apiUrl = 'https://prod.zizazz.com/ziz/api/v1/';


    }

  
showDeletePopup(){
     let disposable = this.dialogService.addDialog(PopupLogoutComponent, {
                title:'Delete Identified', 
                message:'You have been deleted by the admin.You are being automatically logged out from this device.'})
               this.dataRemoval();  
}
showBlockPopup(){
      let disposable = this.dialogService.addDialog(PopupLogoutComponent, {
                title:'Block Identified', 
                message:'You have been blocked by the admin.You are being automatically logged out from this device.'})
             this.dataRemoval();    
}
   showLogoutPopup() {
                this.localstorage.setStorage("showloginpopup",false);
                let disposable = this.dialogService.addDialog(PopupLogoutComponent, {
                title:'Multiple Login Identified', 
                message:'You are allowed to access ZIZ from only one device at a time.You are being automatically logged out from this device.'})
                this.dataRemoval();
   }

     showAccessPopup() {
          
            let disposable = this.dialogService.addDialog(PopupLogoutComponent, {
                title:'Access Denied', 
                message:'You are not allowed for this operation.You are being automatically logged out from this device.'})
          this.dataRemoval();
   }

   dataRemoval(){
         var getId =  this.localstorage.getStorage('userID');
                var gettoken = parseInt(this.localstorage.getStorage("usertype"));
                console.log("gettoken"+gettoken);                
                console.log(getId);
                this.localstorage.removeStorage('token'); 
                this.localstorage.removeStorage('userID'); 
                this.localstorage.removeStorage("payreceipt");
                localStorage.removeItem('latitude1');
                localStorage.removeItem('longitutde1');   
                this.localstorage.removeStorage('selectedSegements');
                this.localstorage.removeStorage('groupnotificationstatus'); 
                this.localstorage.removeStorage('disablenotificationID');
                this.localstorage.removeStorage("pay");
                this.localstorage.removeStorage('active');
              
               
                setTimeout(function () {
                    if(gettoken===1) {
                                
                        this.router.navigate(['users/login']); 
                        this.closePopup();
                        this.localstorage.removeStorage('usertype'); 
                        //window.location.reload(); 
                        this._compiler.clearCache();   
                    }
                    else if(gettoken===2) {
                        this.router.navigate(['advertiser/adlogin']); 
                        this.closePopup();
                        //window.location.reload();
                        this._compiler.clearCache();    
                    }
                    else if(gettoken===3){
                        this.router.navigate(['admin/login']); 
                        this.closePopup();
                        //window.location.reload();  
                        this._compiler.clearCache();
                    }
                    else {
                        this.router.navigate(['']); 
                        this.closePopup();
                        this._compiler.clearCache();
                    }

                }.bind(this), 6000);
   }


   closePopup() {
       this.dialogService.removeAll();
   }
//    getIp() {
//        $.getJSON('//freegeoip.net/json/?callback=?', function(data) {
//   console.log(JSON.stringify(data, null, 2));
// });
//    }

getIp() : Observable<any>{
         return this.http.get("https://jsonip.com/", function(data) {
          return data;
        }).do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
                let result = res;
                return result;
                // else {
                //     return false;
                // }
            })
.catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });}

 
    callApi(api: string, data: any): Observable<any> {
        let headers = new Headers({
        'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });
        let apiUrl = this.baseUrl + api;
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
          .map((res: Response) => {
                let result = res.json();
                if(result) {
                    if(result.meta.code===130) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                        // this.loaderService.displayLoader(false);
                    }
                    else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                    else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
             .catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });
    }

    callApiv2(api: string, data: any): Observable<any> {
        let headers = new Headers({
        'Content-Type': 'application/json'
        });
        let options = new RequestOptions({ headers: headers });
        let apiUrl = this.baseUrlv2 + api;
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
          .map((res: Response) => {
                let result = res.json();
                if(result) {
                    if(result.meta.code===130) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                        // this.loaderService.displayLoader(false);
                    }
                    else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                    else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
             .catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });
    }


getCompanyData= (keyword: any): Observable<any[]> => {
         let headers = new Headers();
         let options = new RequestOptions({ headers: headers, withCredentials: false });
         let getapiUrl = this.baseUrl + "master/searchCompanyByName?currentPage=1&currentSize=5&q="+keyword;
        if(keyword!="") {
         return this.http.get(getapiUrl, options)
         .do(options => ('All: ' + JSON.stringify(options)))
              .map((res: Response) => {
                let result = res.json();
                if(result) {
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                        console.log(result.data);
                        return result.data;
                    }
                } 
                // else {
                //     return false;
                // }
            })
        }
    }

// getCompanyData = (keyword: any): Observable<any[]> => {
    
//     let url: string = this.baseUrl+'master/searchCompanyByName?currentPage=1&currentSize=5&q=a'
//     if (keyword) {
//       return this.http.get(url)
//         .map(res => {
//           let json = res.json();
//           return json.data;
//         })
//     } else {
//       return Observable.of([]);
//     }
//   }

    callApiWithTokenMultipart(api: string, data: any,token:any): Observable<any>{
        console.log(token);  
        let headers = new Headers({
            // 'Content-Type':'multipart/form-data',
            'Accept' : 'application/json'
        });
        headers.append('Authorization', token);
       let options = new RequestOptions({ headers: headers });
        let apiUrl = this.baseUrl + api;
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
                let result = res.json();
                if(result) {
                   console.log(result)
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                    }
                     else if(result.meta.code===403) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup(); 
                    }
                       else if(result.meta.code===164){
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
            })
             .catch(
                 (error: any) => {
                if (error.status === 500 || error.status === "500" ) {
                            this.showDeletePopup();
                }
            else {
              return Observable.throw(new Error(error.status));
            }
        }); 
    }

     callApiWithToken(api: string, data: any,token:any): Observable<any> {
        console.log(token);  
        let headers = new Headers({
        'Content-Type': 'application/json'
        });
        headers.append('Authorization', token);
       let options = new RequestOptions({ headers: headers });
        let apiUrl = this.baseUrl + api;
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
             //console.log("rrsponse"+res.json().meta.code);
                let result = res.json();
                if(result) {
                   console.log(result)
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
             .catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });
    }
    
    callApiWithTokenv2(api: string, data: any,token:any): Observable<any> {
        console.log(token);  
        let headers = new Headers({
        'Content-Type': 'application/json'
    });
        headers.append('Authorization', token);
       let options = new RequestOptions({ headers: headers });
        let apiUrl = this.baseUrlv2 + api;
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
             //console.log("rrsponse"+res.json().meta.code);
                let result = res.json();
                if(result) {
                   console.log(result)
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
             .catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });
    }

     callApiWithTokenDelete(api: string, data: any,token:any): Observable<any> {
        let headers = new Headers({
        'Content-Type': 'application/json'
    });
        headers.append('Authorization', token);
       let options = new RequestOptions({ headers: headers });
        let apiUrl = this.baseUrl + api;
        return this.http.delete(apiUrl, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
             console.log("rrsponse"+res.json().meta.code);
                let result = res.json();
                                   console.log(result)

                if(result) {
                     console.log(result)
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
.catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });    }
    
uploadImage(api: string, data: any,token:any): Observable<any> {
    console.log(data);
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Authorization', token);
        let options = new RequestOptions({ headers: headers });
        let apiUrl = this.baseUrl + api;
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
             console.log("rrsponse"+res.json().meta.code);
                let result = res.json();
                                   console.log(result)


                if(result) {
                    console.log(result)
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                       
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
.catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });     }

     CallData(api: string, data: any) {
         let getapiUrl = this.baseUrl + api;
         return this.http.get(getapiUrl, data)
         .do(data => "")
              .map((res: Response) => {
                let result = res.json();
                if(result) {
                     console.log(result)
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
    }

    CallDatawithTokenAjax(api: string, data: any,token){
        let getapiUrl = this.baseUrl + api;
        return $.ajax({
        type: "GET",
        url: getapiUrl,
        async: false,
        success: function (result) {
            /* if result is a JSon object */
           
                return result;
           
        }
    });
    }
     CallDatawithToken(api: string, data: any,token):Observable<any> {
         console.log(data);
         let headers = new Headers();
         headers.append('Authorization', token);
         let options = new RequestOptions({ headers: headers, withCredentials: false });
         let getapiUrl = this.baseUrl + api;
                 console.log(getapiUrl);

         return this.http.get(getapiUrl, options)
         .do(options => ('All: ' + JSON.stringify(options)))
            .map((res: Response) => {
                console.log("getapiUrl 4444");
                console.log(res);

                let result = res.json();
                console.log(result);
                if(result) {
                     console.log(result.meta.code)
                    if(result.meta.code===130) {
                        console.log("inside logout");
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        if(this.localstorage.getStorage("showloginpopup")){this.showLogoutPopup();}
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
                        console.log("inside logout 111");

 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
                                console.log("inside logout 2222");

 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else if (result.meta.code==401){
                      this.localstorage.removeStorage('token');
                      this.localstorage.removeStorage('start');
                      this.localstorage.removeStorage('selectedSegements');
                      this.localstorage.removeStorage('usertype');
                      this.localstorage.removeStorage('campaignId');
                      this.localstorage.removeStorage("payreceipt");
                      this.localstorage.removeStorage("pay");
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            }

            )
.catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        }); 
    }





    CallDatawithTokenShare(api: string, data: any,token) {
         let headers = new Headers();
         headers.append('Authorization', token);
         let options = new RequestOptions({ headers: headers, withCredentials: false });
         let getapiUrl = this.baseUrl + api;
        
         return this.http.get(getapiUrl, options)
         .do(options => ('All: ' + JSON.stringify(options)))
              .map((res: Response) => {
                  console.log(res);
               return res;      
            })
    }
    getFacebookdata(token: string) {
         let getapiUrl = "https://graph.facebook.com/me?access_token="+token+"&fields=id,name,email,picture,first_name,last_name,about,middle_name,gender,age_range,birthday";
         return this.http.get(getapiUrl)
         .do(data => console.log('All: ' + JSON.stringify(data)))
              .map((res: Response) => {
                let result = res.json();
                if(result) {
                   return result;
                } else {
                    return false;
                }
            })
    }
    // Method Written for API Call 
    getAllFeed(api: string, data: any,token):Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', token);
         let options = new RequestOptions({ headers: headers, withCredentials: false });
         let getapiUrl = this.baseUrl + api;
         return this.http.get(getapiUrl, options)
         .do(options => ('All: ' + JSON.stringify(options)))
              .map((res: Response) => {
                let result = res.json();
                if(result) {
                     console.log(result)
                    if(result.meta.code===130) {
                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        console.log("showloginpopup"+this.localstorage.getStorage("showloginpopup"));
                        if(this.localstorage.getStorage("showloginpopup")){
                            this.showLogoutPopup();
                        }
                    }
                     else if(result.meta.code===403) {

                        this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showAccessPopup();
                        
                    }
                       else if(result.meta.code===164){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showBlockPopup();
                    }
                    else if (result.meta.code===165){
 this.rerenderLogoutpopup = true;
                        this.clearIndexDb();
                        this.showDeletePopup();
                    }
                    else {
                   return result;
                    }
                } 
                // else {
                //     return false;
                // }
            })
        }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        }    
    groupPushNotification(notification: any, userID: number) {
        var description;
                  console.log("notificationID"+notification[0].id);   

        var descriptionText = this.capitalizeFirstLetter(notification[0].description)
        if(notification[0].count>1) {
             description = notification[0].count + ' ' + descriptionText + ' ' + 'deals around you';
            
        }
        else {
           //description = notification[0].description;   
           description = notification[0].count + ' ' + descriptionText + ' ' + 'deal around you';
    }
          let headers = new Headers({
        'Content-Type': 'application/json'
    });

          // Dev Header  
       // headers.append("Authorization", "Basic NjE0M2NmZjYtNmEzNy00OGM3LTg2Y2ItNDc1ZmEzODYwYmI1") 
         // QA header
    //headers.append("Authorization", "Basic ZTIwNWQ5MGEtYmIyMy00NmRhLWIxMjEtMWJmNTJiN2MzYWU0") 
         //Staging Header
     headers.append("Authorization", "Basic ZjhkZWI4YWUtZTk4OC00ZTBkLTk2OGMtYTgyZjViZDg4MjA1")
         let options = new RequestOptions({ headers: headers });
        let apiUrl = "https://onesignal.com/api/v1/notifications";
        let data= {
            // Staging URL
           "app_id": "1d82da5d-d962-4486-9baa-0991eaadafd6",
            
            //Dev URL
         //  "app_id": "b655c909-3b87-4dc1-9855-d0641b9d48de",

            // QA URL
        
        //"app_id": "32473e8c-4ba6-4df6-97c1-ea871500aef9",
              
            //"app_id":"5331dee0-2a85-4850-aee5-f53bc04da63d",
           // "included_segments": ["All"],

            // Dev Safari Web Push
       // "safari_push_id": "web.onesignal.auto.30b8db8e-86b1-4367-8886-055d3d362718",

            // QA Safari Web Push    
        //"safari_push_id": "web.onesignal.auto.43666e9c-a8ad-4b1e-8de4-10291bcbdb86",
            
            // staging Safari Web Push    
         "safari_push_id": "web.onesignal.auto.6a162863-2269-421e-a6d3-46e81aa6d2f4",


            "filters": [
            {"field": "tag", "key": "userID", "relation": "=", "value": userID}
             ],
            "url":"https://staging.zizazz.com/zizapp/#/users/wallnotification/"+notification[0].id,
            "contents": {"en": description}
            }
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
                let result = res;
                if(result) {
                    console.log(result);
                   return result;
                } else {
                    return false;
                }
            })
.catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });         
    }

        singlePushNotification(description: string, notificationID: number, userID: number) {
        //   description = description + ' ' + ' deal around you';
          description = description  
          console.log("notificationID"+notificationID);   
          let headers = new Headers({
        'Content-Type': 'application/json'
    });

       
        // Dev Header
      //  headers.append("Authorization", "Basic NjE0M2NmZjYtNmEzNy00OGM3LTg2Y2ItNDc1ZmEzODYwYmI1") 
        
        //QA Hedaer
     //headers.append("Authorization", "Basic ZTIwNWQ5MGEtYmIyMy00NmRhLWIxMjEtMWJmNTJiN2MzYWU0")
        
        //Staging Header
      headers.append("Authorization", "Basic ZjhkZWI4YWUtZTk4OC00ZTBkLTk2OGMtYTgyZjViZDg4MjA1")

         let options = new RequestOptions({ headers: headers });
        let apiUrl = "https://onesignal.com/api/v1/notifications";
        let data= {
        
            // Staging URL

        "app_id": "1d82da5d-d962-4486-9baa-0991eaadafd6",
           
            // QA URL
            
     //"app_id": "32473e8c-4ba6-4df6-97c1-ea871500aef9",
            
            // Dev URL
            
          //  "app_id" : "b655c909-3b87-4dc1-9855-d0641b9d48de",  
           
            // Dev Safari ID


          // "safari_push_id": "web.onesignal.auto.30b8db8e-86b1-4367-8886-055d3d362718",

            // QA Safari ID
        // "safari_push_id": "web.onesignal.auto.43666e9c-a8ad-4b1e-8de4-10291bcbdb86",
             
             // Staging Safari ID
      "safari_push_id": "web.onesignal.auto.6a162863-2269-421e-a6d3-46e81aa6d2f4",
             
            // "included_segments": ["All"],
            
            "filters": [
            {"field": "tag", "key": "userID", "relation": "=", "value": userID}
             ],
            "url":"https://staging.zizazz.com/zizapp/#/users/wallnotification/"+notificationID,
            "contents": {"en": description}
            }
        return this.http.post(apiUrl, data, options)
        .do(data => console.log('All: ' + JSON.stringify(data)))
         .map((res: Response) => {
                let result = res;
                if(result) {
                   return result;
                } else {
                    return false;
                }
            })
.catch(
                 (error: any) => {
            if (error.status === 500 || error.status === "500" ) {
                        this.showDeletePopup();
            }
            else {
              return Observable.throw(new Error(error.status));
            }
        });        
    }

    getCurrentLatLong(){
        console.log("Location changed");
        if(navigator.geolocation){
            navigator.geolocation.getCurrentPosition(this.setPosition.bind(this));
             var token = (this.localstorage.getStorage('token')); 
             var getUserType = parseInt(this.localstorage.getStorage('usertype'));
              if(getUserType===1) {
            console.log(this.currentLatLong)
            return (this.currentLatLong);
        }
        else {

        clearInterval(getUserType);
    }
        }

    }
    setPosition(position){
       this.currentLatLong=[];  
      console.log("inside function");
    this.location = position.coords;
    this.currentLat1 = position.coords.latitude;
    this.currentlong1 = position.coords.longitude;
    this.currentLatLong.push(this.currentLat1);
    this.currentLatLong.join(',')
    this.currentLatLong.push(this.currentlong1);
    this.lat1 = localStorage.getItem('latitude1');
    this.long1 = localStorage.getItem('longitutde1')
    if(!(this.lat1) && !(this.long1)){
      console.log("IST CALLED")  
     var distanceTravelled = 0;   
    this.lat1 = this.currentLat1;
    this.long1 = this.currentlong1;
    localStorage.setItem('latitude1',this.lat1);
    localStorage.setItem('longitutde1', this.long1);
    this.currentLatLong.join(',')
    this.currentLatLong.push(distanceTravelled);
}
    else if((this.currentLat1!=this.lat1) && (this.currentlong1!=this.long1)) {
        console.log("2nd CALLED")  
       var calculatedistance = this.calculateDistacePing(this.lat1, this.long1, this.currentLat1, this.currentlong1);
       console.log(calculatedistance)
       this.currentLatLong.join(',')
       this.currentLatLong.push(calculatedistance);
       console.log(this.currentLatLong);
    }
    else {
         console.log("3rd CALLED")  
         var distanceTravelled = 0;
         this.currentLatLong.join(',')
         this.currentLatLong.push(0); 
    }
    }

calculateDistacePing(lat1, long1, currentLat1, currentLong1) {
    console.log("inside Another function");
     var radlat1 = Math.PI * lat1/180;
     var radlat2 = Math.PI * lat1/180;
     var theta = long1-currentLong1;
     var radtheta = Math.PI * theta/10;
     var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
     dist = Math.acos(dist)
     dist = dist * 180/Math.PI
     dist = dist * 60 * 1.1515
     dist = dist * 1.609344;
     this.distcalc = this.distcalc + dist
    //  this.currentLatLong.join(',')
    //  this.currentLatLong.push(this.distcalc);
      localStorage.setItem('latitude1',this.currentLat1);
     localStorage.setItem('longitutde1', this.currentlong1);
    return this.distcalc;

}
    clearIndexDb() {
           this.indexedDB.openDBAsync("Angular2IndexedDB", 1).forEach(
                (readyState: string) => {
                    
                    console.log('IndexedDB service: opening db: ' + readyState);
                    // if(readyState === 'done'){
                    //   this.todo.addTodo("Hello");
                    // }
                }
              ).then(
                  () => {
                this.indexedDB.clearObjectStoreAsync("TodoStore").forEach(
                (readyState: string) => {
                   console.log('Index DB cleared: ' + readyState);
                }
              )
                  }
              ) 
         
    }
     handleError(error: Response){
        console.error(error.status);
        if(error.status == 500){
           
                return Observable.throw('Unauthorized');
        }
    else{
         return Observable.throw(error.json().error || "server error");

    }
    }


    
}







// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts